var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view", staticStyle: { "padding-top": "5px" } },
    [
      _c(
        "query-bill-payment",
        {
          ref: "queryBillPayment",
          attrs: {
            "is-append-query": _vm.isAppendQuery,
            identify: "queryBillPayment",
            "view-source": "billPaymentList",
            "show-real-clearing-state":
              _vm.searchConditions.showRealClearingState,
            state: _vm.searchConditions.state,
            "paid-off": _vm.searchConditions.paidOff,
            "fin-approve-state": _vm.searchConditions.finApproveState,
            "is-check-charge": _vm.searchConditions.isCheckCharge,
            "show-controlled-charge": _vm.searchConditions.showControlledCharge,
            "show-fba": false,
            "input-date-start": _vm.searchConditions.inputDateStart,
            "input-date-end": _vm.searchConditions.inputDateEnd,
            "clearing-states": _vm.searchConditions.clearingStates,
            "show-wht": _vm.showWht,
            "is-default-bill-payment": true,
            "config-module": "508",
            "grid-config-module": "190801"
          },
          on: {
            dataProviderChange: _vm.dataProviderChange,
            rowDoubleClicked: _vm.rowDoubleClicked,
            toSearchTemplate: _vm.toSearchTemplate
          },
          scopedSlots: _vm._u([
            {
              key: "searchAreaHeader",
              fn: function() {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "app-main-inner-row  extension-conditions-form"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "filters" },
                        [
                          _c(
                            "el-form",
                            {
                              attrs: {
                                inline: true,
                                "label-width": _vm.isZh ? "60px" : "155px",
                                "label-position": "left"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "el-form-item-wrapper dense-radio-group"
                                },
                                [
                                  !_vm.billPaymentSetting.openUiCustom
                                    ? _c(
                                        "el-form-item",
                                        {
                                          staticClass: "dense-radio-group",
                                          attrs: {
                                            label: _vm.$t(
                                              "Payment.applicationStatus"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio-group",
                                            {
                                              attrs: { no: "13" },
                                              on: {
                                                change:
                                                  _vm.applicationStatusChange
                                              },
                                              model: {
                                                value:
                                                  _vm.searchConditions
                                                    .applicationStatus,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.searchConditions,
                                                    "applicationStatus",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "searchConditions.applicationStatus"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-radio",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.$checkPermission(
                                                        ["tab_ACPayAuth_fbWait"]
                                                      ),
                                                      expression:
                                                        "$checkPermission(['tab_ACPayAuth_fbWait'])"
                                                    }
                                                  ],
                                                  attrs: { no: "14", label: 0 }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Payment.notSubmitted"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-radio",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.$checkPermission(
                                                        [
                                                          "tab_ACPayAuth_fbApproval"
                                                        ]
                                                      ),
                                                      expression:
                                                        "$checkPermission(['tab_ACPayAuth_fbApproval'])"
                                                    }
                                                  ],
                                                  attrs: { no: "15", label: 1 }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Payment.awaitBusinessApproval"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-radio",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.$checkPermission(
                                                        [
                                                          "tab_ACPayAuth_fbFinanceVerify"
                                                        ]
                                                      ),
                                                      expression:
                                                        "$checkPermission(['tab_ACPayAuth_fbFinanceVerify'])"
                                                    }
                                                  ],
                                                  attrs: { no: "16", label: 2 }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Payment.awaitFinancialApproval"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-radio",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.$checkPermission(
                                                        [
                                                          "tab_ACPayAuth_fbConfirm"
                                                        ]
                                                      ),
                                                      expression:
                                                        "$checkPermission(['tab_ACPayAuth_fbConfirm'])"
                                                    }
                                                  ],
                                                  attrs: { no: "17", label: 3 }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("Payment.approval")
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-radio",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.$checkPermission(
                                                        [
                                                          "tab_ACPayAuth_fbUnverify"
                                                        ]
                                                      ),
                                                      expression:
                                                        "$checkPermission(['tab_ACPayAuth_fbUnverify'])"
                                                    }
                                                  ],
                                                  attrs: { no: "18", label: 4 }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("Payment.unpaid")
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-radio",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.$checkPermission(
                                                        ["tab_ACPayAuth_fbAll"]
                                                      ),
                                                      expression:
                                                        "$checkPermission(['tab_ACPayAuth_fbAll'])"
                                                    }
                                                  ],
                                                  attrs: { no: "19", label: 5 }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("Payment.all")
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "Billing.billingJob_billPaymentDate"
                                        )
                                      }
                                    },
                                    [
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 8 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: { "label-width": "0" }
                                                },
                                                [
                                                  _c("el-date-picker", {
                                                    staticStyle: {
                                                      width: "100%"
                                                    },
                                                    attrs: {
                                                      no: "20",
                                                      type: "date",
                                                      clearable: false,
                                                      "value-format":
                                                        "yyyy-MM-dd",
                                                      "picker-options":
                                                        _vm.pickerOptions
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.searchConditions
                                                          .inputDateStart,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.searchConditions,
                                                          "inputDateStart",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "searchConditions.inputDateStart"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c("el-col", { attrs: { span: 1 } }, [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-size": "12px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Billing.billingJob_dateTo"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 8 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: { "label-width": "0" }
                                                },
                                                [
                                                  _c("el-date-picker", {
                                                    staticStyle: {
                                                      width: "100%"
                                                    },
                                                    attrs: {
                                                      no: "22",
                                                      type: "date",
                                                      clearable: "",
                                                      "value-format":
                                                        "yyyy-MM-dd",
                                                      "picker-options":
                                                        _vm.pickerOptions
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.searchConditions
                                                          .inputDateEnd,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.searchConditions,
                                                          "inputDateEnd",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "searchConditions.inputDateEnd"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            {
                                              staticStyle: {
                                                "padding-left": "5px"
                                              },
                                              attrs: { span: 7 }
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: { "label-width": "0" }
                                                },
                                                [
                                                  _c(
                                                    "el-checkbox",
                                                    {
                                                      attrs: { no: "23" },
                                                      model: {
                                                        value:
                                                          _vm.allowTwoYearOutside,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.allowTwoYearOutside = $$v
                                                        },
                                                        expression:
                                                          "allowTwoYearOutside"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "Billing.billingJob_lockCheckBoxDate"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "div",
            { attrs: { slot: "operations" }, slot: "operations" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "1", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.toDetail(false, null)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.viewDetails")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "2", type: "primary" },
                  on: { click: _vm.toCollectInvoice }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.collectInvoice")))]
              ),
              _c(
                "el-dropdown",
                {
                  staticStyle: { margin: "0 5px" },
                  attrs: { no: "3", "split-button": "", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.toPrint(_vm.$t("Payment.print"))
                    },
                    command: _vm.toPrint
                  }
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("Payment.print")) + " "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            command: _vm.$t(
                              "Clearing.PrintByPaymentRequestNumber"
                            )
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Clearing.PrintByPaymentRequestNumber")
                            )
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "4", type: "primary" },
                  on: { click: _vm.toCreatePayment }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.newPaymentRequest")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.searchConditions.applicationStatus === 0,
                      expression: "searchConditions.applicationStatus === 0"
                    }
                  ],
                  attrs: { no: "5", type: "primary" },
                  on: { click: _vm.doCommit }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.submit")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        (_vm.searchConditions.applicationStatus === 0 ||
                          _vm.searchConditions.applicationStatus === 4) &&
                        this.$checkPermission([
                          "button_ACPayAuth_btnBillDelete"
                        ]),
                      expression:
                        "(searchConditions.applicationStatus === 0 || searchConditions.applicationStatus === 4) && this.$checkPermission(['button_ACPayAuth_btnBillDelete'])"
                    }
                  ],
                  attrs: { no: "6", type: "danger" },
                  on: { click: _vm.doDelete }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Payment.delete")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.searchConditions.applicationStatus === 1 &&
                        this.hasBusinessVerify,
                      expression:
                        "searchConditions.applicationStatus === 1 && this.hasBusinessVerify"
                    }
                  ],
                  attrs: { no: "7", type: "primary" },
                  on: { click: _vm.businessApprovalCheck }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Payment.businessApproval")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        (_vm.searchConditions.applicationStatus === 1 &&
                          this.isDepartmentPermit &&
                          !_vm.billPaymentSetting.openUiCustom) ||
                        (_vm.isUiDepartmentApproval &&
                          _vm.searchConditions.applicationStatus === 6),
                      expression:
                        "(searchConditions.applicationStatus === 1 && this.isDepartmentPermit && !billPaymentSetting.openUiCustom) || (isUiDepartmentApproval && searchConditions.applicationStatus === 6)"
                    }
                  ],
                  attrs: { no: "8", type: "primary" },
                  on: { click: _vm.departmentApprovalCheck }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("Payment.departmentApproval")) + " "
                  )
                ]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.searchConditions.applicationStatus === 2 &&
                        this.$checkPermission([
                          "button_ACPayAuth_financeVerify"
                        ]),
                      expression:
                        "searchConditions.applicationStatus === 2 && this.$checkPermission(['button_ACPayAuth_financeVerify'])"
                    }
                  ],
                  attrs: { no: "9", type: "primary" },
                  on: { click: _vm.financialApprovalCheck }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("Payment.financialApproval")) + " "
                  )
                ]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.searchConditions.applicationStatus === 11 &&
                        _vm.isUiSupervisorApproval &&
                        this.$checkPermission([
                          "button_ACPayAuth_supervisorVerify"
                        ]),
                      expression:
                        "searchConditions.applicationStatus === 11 && isUiSupervisorApproval && this.$checkPermission(['button_ACPayAuth_supervisorVerify'])"
                    }
                  ],
                  attrs: { no: "11", type: "primary" },
                  on: { click: _vm.supervisorAuditCheck }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("CargoMsg.Cargo_SupervisorReview")) +
                      " "
                  )
                ]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        (_vm.searchConditions.applicationStatus === 1 &&
                          this.hasBackPrivilege) ||
                        ((_vm.searchConditions.applicationStatus === 2 ||
                          _vm.searchConditions.applicationStatus === 3 ||
                          _vm.searchConditions.applicationStatus === 6 ||
                          _vm.searchConditions.applicationStatus === 11) &&
                          this.hasFinanceVerify),
                      expression:
                        "(searchConditions.applicationStatus === 1 && this.hasBackPrivilege) || ((searchConditions.applicationStatus === 2 || searchConditions.applicationStatus === 3 || searchConditions.applicationStatus === 6 || searchConditions.applicationStatus === 11) && this.hasFinanceVerify)"
                    }
                  ],
                  attrs: { no: "10", type: "primary" },
                  on: { click: _vm.backCheck }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Payment.return")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.searchConditions.applicationStatus === 1 &&
                        this.$checkPermission([
                          "button_ACPayAuth_financeVerify"
                        ]) &&
                        !_vm.billPaymentSetting.openUiCustom,
                      expression:
                        "(searchConditions.applicationStatus === 1 && this.$checkPermission(['button_ACPayAuth_financeVerify']) && !billPaymentSetting.openUiCustom)"
                    }
                  ],
                  attrs: { no: "11", type: "primary" },
                  on: { click: _vm.financialAuditCheck }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Payment.financialAudit")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showChangeBillPaymentBtn,
                      expression: "showChangeBillPaymentBtn"
                    }
                  ],
                  attrs: { no: "12", type: "primary" },
                  on: { click: _vm.toBatchChangeTime }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.changePaymentRequest")))]
              )
            ],
            1
          )
        ]
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          },
          selectedTemplate: _vm.updatePrintField
        }
      }),
      _c("make-invoice-dialog", {
        ref: "invoice",
        attrs: { "view-source": "billPaymentList", location: "location" },
        on: { reloadData: _vm.reloadData }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.agreeDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_Tips"),
            "close-on-click-modal": false,
            "show-close": false,
            width: "450px",
            height: "400px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.agreeDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: {
                "flex-direction": "column",
                "padding-bottom": "10px"
              }
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    "text-align": "left",
                    "font-size": "14px",
                    "padding-bottom": "20px"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.Cargo_ApplicantPassTips")))]
              ),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 6,
                  placeholder: _vm.$t("Payment.approveReason")
                },
                model: {
                  value: _vm.agreeDialog.remark,
                  callback: function($$v) {
                    _vm.$set(_vm.agreeDialog, "remark", $$v)
                  },
                  expression: "agreeDialog.remark"
                }
              })
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.agreeHandler } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function() {
                      _vm.agreeDialog.visible = false
                      _vm.agreeDialog.remark = ""
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.returnDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_Tips"),
            "close-on-click-modal": false,
            "show-close": false,
            width: "450px",
            height: "400px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.returnDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: {
                "flex-direction": "column",
                "padding-bottom": "10px"
              }
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    "text-align": "left",
                    "font-size": "14px",
                    "padding-bottom": "20px"
                  }
                },
                [_vm._v(_vm._s(_vm.returnDialog.returnTips))]
              ),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 6,
                  placeholder: _vm.$t("Payment.returnReason")
                },
                model: {
                  value: _vm.returnDialog.remark,
                  callback: function($$v) {
                    _vm.$set(_vm.returnDialog, "remark", $$v)
                  },
                  expression: "returnDialog.remark"
                }
              })
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.doBack } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function() {
                      _vm.returnDialog.visible = false
                      _vm.returnDialog.remark = ""
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _vm.changePaymentDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "changePaymentRequest",
              attrs: {
                visible: _vm.changePaymentDialog.visible,
                title: _vm.$t("CargoMsg.Cargo_ChangePayment"),
                width: "450px",
                height: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.changePaymentDialog, "visible", $event)
                }
              }
            },
            [
              [
                _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "dialog-body",
                      staticStyle: {
                        "padding-left": "10px",
                        "padding-top": "20px",
                        "padding-bottom": "26px"
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "name" }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_PaymentTimeLimit"))
                            )
                          ]),
                          _c("el-date-picker", {
                            attrs: {
                              clearable: false,
                              editable: false,
                              type: "date"
                            },
                            model: {
                              value: _vm.changePaymentDialog.deadLine,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.changePaymentDialog,
                                  "deadLine",
                                  $$v
                                )
                              },
                              expression: "changePaymentDialog.deadLine"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: { "margin-top": "7px", display: "flex" }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "name",
                              staticStyle: {
                                width: "25px",
                                "margin-left": "23px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Remarks")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column"
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "220px" },
                                attrs: { type: "textarea", rows: 5 },
                                model: {
                                  value: _vm.changePaymentDialog.remark,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.changePaymentDialog,
                                      "remark",
                                      $$v
                                    )
                                  },
                                  expression: "changePaymentDialog.remark"
                                }
                              }),
                              _c(
                                "span",
                                { staticStyle: { "margin-top": "7px" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_BillPaymentRemarkTip"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      staticStyle: { "justify-content": "right" },
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.changePaymentConfirm }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function($event) {
                              _vm.changePaymentDialog.visible = false
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                      )
                    ],
                    1
                  )
                ])
              ]
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }